import {
  jbLinkClickedEventToJbTrackingEvent,
  setLink
} from "./chunk.VPBTB6HE.js";
import {
  __decorateClass
} from "./chunk.7VONTVYH.js";

// src/components/jb-footer/jb-footer.ts
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

// src/components/jb-footer/jb-footer.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_footer_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
.copyright, .link {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-weight: 700;
}

p {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-style: normal;
  font-weight: 300;
}

p {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, 0.7));
  font-size: 13px;
  line-height: 20px;
}

p {
  color: rgba(var(--rgb-primary, 255, 255, 255), var(--text-opacity, 0.7));
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

footer {
  --_notch-max-inset: max(env(safe-area-inset-left), env(safe-area-inset-right));
  --_notch-inset: calc(var(--_notch-max-inset) + 5px);
  --_notch-inset-padding: max(40px, var(--_notch-inset));
  background-color: #141e55;
  padding: 51px calc(var(--_notch-inset-padding) + var(--compensate-scrollbar, 0px)) 42px var(--_notch-inset-padding);
  position: relative;
  --rgb-primary: 255, 255, 255;
}
@media (min-width: 600px) and (max-width: 959px) {
  footer {
    --_notch-inset-padding: max(20px, var(--_notch-inset));
    padding: 51px calc(var(--_notch-inset-padding) + var(--compensate-scrollbar, 0px)) 42px var(--_notch-inset-padding);
  }
}
@media (max-width: 599px) {
  footer {
    --_notch-inset-padding: max(28px, var(--_notch-inset));
    padding: 40px calc(var(--_notch-inset-padding) + var(--compensate-scrollbar, 0px)) 41px var(--_notch-inset-padding);
  }
}
@media (max-width: 599px) {
  footer {
    --item-display: block;
    --item-margin-right: 0;
    --item-margin-bottom: 15px;
  }
  footer:last-child {
    --item-display: inline-block;
    --item-margin-bottom: 3px;
  }
}
@media (max-width: 599px) and (max-width: 599px) {
  footer:last-child {
    --item-margin-bottom: 0;
  }
}
@media (max-width: 599px) {
  footer:nth-child(4) {
    --item-display: inline-block;
    --item-margin-bottom: 0;
  }
}

.wrapper {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
}

.primary {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 20px;
  width: 100%;
  margin-bottom: 53px;
  font-size: 0;
  font-size: 0;
}
@media (min-width: 600px) {
  .primary {
    box-sizing: border-box;
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 20px;
    width: 50%;
  }
}
@media (min-width: 1281px) and (max-width: 1436px) {
  .primary {
    padding-left: 4px;
  }
}
@media (min-width: 960px) and (max-width: 1280px) {
  .primary {
    padding-left: 0;
  }
}
@media (max-width: 959px) {
  .primary {
    padding-left: 0;
  }
}
@media (max-width: 599px) {
  .primary {
    margin-bottom: 30px;
    text-align: center;
  }
}
@media (max-width: 959px) {
  .primary {
    padding: 0;
  }
}
@media (min-width: 960px) {
  .primary {
    padding: 0 20px;
  }
}
.primary .link {
  margin-right: 30px;
}
.primary .link a {
  color: #fff;
  transition: color 0.3s ease-in-out 0s;
}
.primary .link:hover a {
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s ease-in-out 0s;
}
.primary .link:last-child {
  margin-right: 0;
}
.primary li {
  display: inline-block;
}

.social-icons {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 20px;
  width: 100%;
  text-align: right;
  font-size: 0;
  font-size: 0;
}
@media (min-width: 600px) {
  .social-icons {
    box-sizing: border-box;
    flex-basis: 50%;
    max-width: 50%;
    padding: 0 20px;
    width: 50%;
  }
}
@media (min-width: 600px) and (max-width: 959px) {
  .social-icons {
    margin-bottom: 44px;
  }
}
@media (max-width: 599px) {
  .social-icons {
    margin-bottom: 37.5px;
    text-align: center;
  }
}
@media (max-width: 959px) {
  .social-icons {
    padding: 0;
  }
}
.social-icons li {
  display: inline-block;
}
.social-icons li a jb-x-icon {
  color: #fff;
}
@media (max-width: 599px) {
  .social-icons {
    text-align: center;
  }
}
.social-icons .twitter {
  margin-right: 43px;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
}
@media (min-width: 600px) and (max-width: 959px) {
  .social-icons .twitter {
    margin-right: 35px;
  }
}
.social-icons .twitter:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease-in-out;
}
.social-icons .twitter svg {
  height: 16px;
  width: 19px;
}
.social-icons .linkedin {
  margin-right: 42px;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
}
@media (min-width: 600px) and (max-width: 959px) {
  .social-icons .linkedin {
    margin-right: 35px;
  }
}
.social-icons .linkedin:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease-in-out;
}
.social-icons .linkedin svg {
  height: 14px;
  width: 14px;
}
.social-icons .youtube {
  margin-right: 45px;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
}
@media (min-width: 600px) and (max-width: 959px) {
  .social-icons .youtube {
    margin-right: 40px;
  }
}
.social-icons .youtube:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease-in-out;
}
.social-icons .youtube svg {
  height: 15px;
  width: 22px;
}
.social-icons .facebook {
  margin-right: 48px;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
}
@media (min-width: 600px) and (max-width: 959px) {
  .social-icons .facebook {
    margin-right: 43px;
  }
}
.social-icons .facebook:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease-in-out;
}
.social-icons .instagram {
  margin-right: 12px;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
}
@media (max-width: 599px) {
  .social-icons .instagram {
    margin-right: 0;
  }
}
.social-icons .instagram:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease-in-out;
}
.social-icons .instagram svg {
  height: 16px;
  width: 16px;
}

.secondary {
  margin-bottom: 20px;
}
@media (min-width: 600px) and (max-width: 959px) {
  .secondary {
    margin-bottom: 21px;
  }
}
@media (max-width: 599px) {
  .secondary {
    margin: 0 0 20px 1px;
  }
}
@media (min-width: 960px) {
  .secondary {
    padding: 0 20px;
  }
}
.secondary ul {
  padding: 0.5px 0;
  font-size: 0;
  font-size: 0;
}
@media (min-width: 600px) and (max-width: 959px) {
  .secondary ul {
    padding: 1px 0;
  }
}
@media (max-width: 599px) {
  .secondary ul {
    text-align: center;
  }
}
.secondary ul li {
  display: inline-block;
  margin-right: 30px;
}
.secondary ul li a {
  color: #fff;
  transition: color 0.3s ease-in-out 0s;
}
.secondary ul li:hover a {
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s ease-in-out 0s;
}
@media (min-width: 600px) and (max-width: 959px) {
  .secondary ul li:first-of-type {
    margin-bottom: 15px;
  }
}
.secondary ul li:last-child {
  margin-right: 0;
}
@media (max-width: 599px) {
  .secondary ul li {
    display: block;
    margin-bottom: 15px;
    margin-right: 0;
  }
  .secondary ul li:last-child {
    display: inline-block;
    margin-bottom: 3px;
  }
}
@media (max-width: 599px) and (max-width: 599px) {
  .secondary ul li:last-child {
    margin-bottom: 0;
  }
}
@media (max-width: 599px) {
  .secondary ul li:nth-child(4) {
    display: inline-block;
    margin-bottom: 0;
  }
}

p {
  letter-spacing: 0.03rem;
  transition: color 0.3s ease-in-out 0s;
}
p a {
  box-shadow: inset 0 -1px 0 0 RGBA(255, 255, 255, 0.3);
  color: rgba(var(--rgb-primary, 255, 255, 255), 0.7);
  padding-bottom: 0.15em;
  text-decoration: none;
}

jb-richtext {
  color: RGBA(255, 255, 255, 0.7);
}
@media (min-width: 960px) {
  jb-richtext {
    padding: 0 20px;
  }
}

.link {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  color: #fff;
  display: inline-block;
  letter-spacing: 1px;
  text-decoration: none;
  text-transform: uppercase;
}

.copyright {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  color: #fff;
  letter-spacing: 1px;
  opacity: 0.6;
  text-transform: uppercase;
}

@media print {
  footer {
    display: none;
  }
  jb-richtext {
    --rgb-primary: 20, 30, 85;
  }
}`;

// src/components/jb-footer/jb-footer.ts
var JbFooter = class extends LitElement {
  constructor() {
    super(...arguments);
    this.text = "";
  }
  _getSocialIcon(service) {
    switch (service) {
      case "facebook":
        return `<jb-facebook-icon></jb-facebook-icon>`;
      case "linkedin":
        return `<jb-linkedin-icon></jb-linkedin-icon>`;
      case "instagram":
        return `<jb-instagram-icon></jb-instagram-icon>`;
      case "twitter":
        return `<jb-x-icon></jb-x-icon>`;
      case "youtube":
        return `<jb-youtube-icon></jb-youtube-icon>`;
      default:
        break;
    }
    return "";
  }
  _renderNavigation(items) {
    return items.map((item) => {
      if (item.link?.href) {
        const anchor = document.createElement("a");
        setLink(anchor, item.link);
        anchor.innerText = item.text;
        anchor.classList.add("link");
        return html`<li class="link">${anchor}</li>`;
      }
      return html`<li class="copyright">${item.text}</li>`;
    });
  }
  _renderSocialIcons(items) {
    return items.map((item) => {
      const anchor = document.createElement("a");
      if (item.link)
        setLink(anchor, item.link);
      anchor.innerHTML = this._getSocialIcon(item.service);
      anchor.classList.add("link");
      return html`<li class="${item.service}">${anchor}</li>`;
    });
  }
  _trackLink(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "footer"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _trackSocial(e) {
    e.detail.type = "social";
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "footer"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return html`
      <footer>
        <div class="wrapper">
          <nav
            class="primary"
            role="navigation"
            aria-label="Footer navigation"
          >
            <ul @jb-link:clicked=${this._trackLink}>
              ${this._renderNavigation(this.primaryNavigation)}
            </ul>
          </nav>
          <div class="social-icons">
            <ul @jb-link:clicked=${this._trackSocial}>
              ${this._renderSocialIcons(this.socialIcons)}
            </ul>
          </div>
        </div>
        <nav
          class="secondary"
          role="navigation"
          aria-label="Footer navigation"
        >
          <ul @jb-link:clicked=${this._trackLink}>
            ${this._renderNavigation(this.secondaryNavigation)}
          </ul>
        </nav>
        <jb-richtext
          size="mini"
          @jb-link:clicked=${this._trackLink}
          >${this.text ? unsafeHTML(this.text) : nothing}</jb-richtext
        >
      </footer>
    `;
  }
};
JbFooter.styles = unsafeCSS(jb_footer_default);
__decorateClass([
  property({ type: Array })
], JbFooter.prototype, "primaryNavigation", 2);
__decorateClass([
  property({ type: Array })
], JbFooter.prototype, "secondaryNavigation", 2);
__decorateClass([
  property({ type: Array })
], JbFooter.prototype, "socialIcons", 2);
__decorateClass([
  property()
], JbFooter.prototype, "text", 2);
JbFooter = __decorateClass([
  customElement("jb-footer")
], JbFooter);

export {
  JbFooter
};
